var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Carousel from '@marketing/components/global/Carousel';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { useMediaQuery } from '@mui/material';
import { clsx } from 'clsx';
function IngredientCard(_a) {
    var name = _a.name, description = _a.description;
    var isMobile = useMediaQuery('(max-width: 768px)');
    return (_jsxs("div", __assign({ className: clsx('flex h-[131px] justify-start flex-col gap-xl-m md:h-[143px] w-[160px] md:w-[220px]', 'px-md-button py-[20px] md:px-[20px] md:py-[20px]', 'rounded-md bg-surface-white border border-border-shoe') }, { children: [_jsx(Heading, __assign({ size: isMobile ? 'xs' : 'sm', className: "uppercase" }, { children: name })), _jsx("p", __assign({ className: "grow" }, { children: description }))] })));
}
function IngredientsCarousel(_a) {
    var content = _a.content;
    var title = content.title, ingredients = content.ingredients;
    return (_jsxs(FlexSection, __assign({ className: "!flex-col", paddingStyle: "px-2xs-gutter pt-sm-gutter pb-lg-gutter md:px-2xl-gutter md:py-3xl-page-bottom-web", backgroundColorStyle: "bg-surface-beige", gapStyle: "gap-xl-m" }, { children: [_jsx(Heading, __assign({ size: "md", className: "self-start" }, { children: title })), _jsx("div", __assign({ className: "hidden md:flex flex-wrap gap-lg-m gap-y-xs-m w-full" }, { children: ingredients.map(function (ingredient, index) { return (_jsx(IngredientCard, __assign({}, ingredient), index)); }) })), _jsx("div", __assign({ className: "block md:hidden" }, { children: _jsx(Carousel, __assign({ theme: "light", childWidth: 160, gap: 12, controlsPadding: "pt-xl-m pb-0", hideOverflow: false }, { children: ingredients.map(function (ingredient, index) { return (_jsx(IngredientCard, __assign({}, ingredient), index)); }) })) }))] })));
}
export default IngredientsCarousel;
